export function pathLooksEmbedded(path) {
  const value = path || '';
  return /(?:\?|&)embed=1(?:&|$)/.test(value) || value.indexOf('embed_token=') !== -1;
}

export function isEmbeddedApp() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.self !== window.top) return true;
  } catch (e) {
    return true;
  }
  try {
    return pathLooksEmbedded(window.location.search);
  } catch (e) {
    return false;
  }
}

export function markEmbeddedApp() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('scorecard-embed');
}

export function persistEmbedMode() {
  const embedded = isEmbeddedApp() || pathLooksEmbedded(
    typeof window === 'undefined' ? '' : window.location.search
  );
  if (embedded) markEmbeddedApp();
  return embedded;
}

export function clearEmbedMode() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove('scorecard-embed');
}
